import { Icon } from '@/general/Icons/Icon';
import { ToastContentProps } from 'react-toastify';

import { ButtonIcon } from '@/general/components/Button/ButtonIcon';

export const CarComparisonDismissSnackbarButton = ({ closeToast }: Pick<ToastContentProps, 'closeToast'>) => (
  <ButtonIcon
    icon={<Icon name="circle-cross-filled" />}
    title="Dismiss"
    onClick={closeToast}
    variant="tertiary"
    size="xsmall"
    styling="round"
  />
);
